import React from 'react';
import classNames from 'classnames';
import PropTypes, { node } from 'prop-types';
import keycode from 'keycode';
import TableFooter from '@material-ui/core/TableFooter';
import Table from '@material-ui/core/Table';
import { connect } from "react-redux";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import { getFormattedDate, getTimeFromTimestamp } from "util/util";
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import FilterListIcon from 'material-ui-icons/FilterList';

let counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return { id: counter, name, calories, fat, carbs, protein };
}

const columnData = [
    { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator', type: 'string' },
    { id: 'time', numeric: false, disablePadding: false, label: 'Last Seen', type: 'date' },
    { id: 'batteryVoltage', numeric: true, disablePadding: false, label: 'Battery Level', type: 'number' },
    { id: 'signalStrength', numeric: true, disablePadding: false, label: 'Signal Strength', type: 'number' },
    { id: 'firmware', numeric: false, disablePadding: false, label: 'Firmware', type: 'string' },
];

class EnhancedTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
                        <Checkbox color="primary"
                                  indeterminate={numSelected > 0 && numSelected < rowCount}
                                  checked={numSelected === rowCount}
                                  onChange={onSelectAllClick}
                        />
                    </TableCell> */}
                    {columnData.map(column => {
                        return (
                            <TableCell
                                style={{
                                    background: '#E2E3E5'
                                }}
                                className={column.id !== 'deviceId' && "text-center"}
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


let EnhancedTableToolbar = props => {
    const { numSelected } = props;

    return (
        <Toolbar
            className={classNames("table-header", {
                ["highlight-light"]: numSelected > 0,
            })}
        >
            <div className="title">
                <Typography type="title">Add Filter</Typography>
            </div>
            <div className="actions">
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                        <Tooltip title="Filter list">
                            <IconButton aria-label="Filter list">
                                <FilterListIcon onClick={() => { props.openModal(); }} />
                            </IconButton>
                        </Tooltip>
                    )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class EnhancedTable extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        let data = [];
        if (orderBy === 'nodeId' || orderBy === 'status') {
            data = order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
        }
        else {
            data =
                order === 'desc'
                    ? this.state.data.sort((aItem, bItem) => {
                        let a = aItem.n ? aItem.n : aItem;;
                        let b = bItem.n ? bItem.n : bItem;
                        return ((b.data && b.data.vitals && b.data.vitals[orderBy] !== undefined && b.data.vitals[orderBy]) < (a.data && a.data.vitals && a.data.vitals[orderBy] !== undefined && a.data.vitals[orderBy]) ? -1 : 1)
                    })
                    : this.state.data.sort((aItem, bItem) => {
                        let a = aItem.n ? aItem.n : aItem;
                        let b = bItem.n ? bItem.n : bItem;
                        return ((a.data && a.data.vitals && a.data.vitals[orderBy] !== undefined && a.data.vitals[orderBy]) < (b.data && b.data.vitals && b.data.vitals[orderBy] !== undefined && b.data.vitals[orderBy]) ? -1 : 1)
                    });
        }
        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, deviceId) => {

        this.props.updateDeviceId(deviceId);
        // const { selected } = this.state;
        // const selectedIndex = selected.indexOf(id);
        // let newSelected = [];

        // if (selectedIndex === -1) {
        //     newSelected = newSelected.concat(selected, id);
        // } else if (selectedIndex === 0) {
        //     newSelected = newSelected.concat(selected.slice(1));
        // } else if (selectedIndex === selected.length - 1) {
        //     newSelected = newSelected.concat(selected.slice(0, -1));
        // } else if (selectedIndex > 0) {
        //     newSelected = newSelected.concat(
        //         selected.slice(0, selectedIndex),
        //         selected.slice(selectedIndex + 1),
        //     );
        // }

        // this.setState({ selected: newSelected });
    };
    handleChangePage = (event, page) => {
        // this.setState({ page });
        this.props.updateNodeVitalsFilterData({
            data: this.state.data,
            pageNumber: page,
        })
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);
        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.nodeVitalsFilter.data,
            page: props.nodeVitalsFilter.pageNumber,
            filterData: props.nodeVitalsData.data,
            rowsPerPage: 25,
        };
    }

    setData(data) {
        this.setState({
            data: data.nodeVitalsFilter.data,
            page: data.nodeVitalsFilter.pageNumber,
            filterData: data.nodeVitalsData.data
        })
    }

    formatDate(date) {
        const updatedTime = `${new Date(date * 1000).getFullYear()}-${(
            "0" +
            (new Date(date * 1000).getMonth() + 1)
        ).substr(-2)}-${("0" + new Date(date * 1000).getDate()).substr(-2)}, ${(
            "0" + new Date(date * 1000).getHours()
        ).substr(-2)}:${("0" + new Date(date * 1000).getMinutes()).substr(-2)}:${(
            "0" + new Date(date * 1000).getSeconds()
        ).substr(-2)}`;
        return updatedTime;
    }

    componentWillReceiveProps(nextProps) {
        this.setData(nextProps);
    }

    showBatteryLevel = (batteryVoltage) => {
        if (batteryVoltage > 6.8) {
            return <i
                className="fa fa-battery-full text-green mx-2 signalBatteryIcon"
                aria-hidden="true"
            />
        } else if (batteryVoltage >= 6.6 && batteryVoltage <= 6.89) {
            return <i
                className="fa fa-battery-three-quarters text-yellow mx-2 signalBatteryIcon"
                aria-hidden="true"
            />

        } else if (batteryVoltage >= 6.0 && batteryVoltage <= 6.59) {
            return <i
                className="fa fa-battery-half display-1 text-orange mx-2 signalBatteryIcon"
                aria-hidden="true"
            />

        } else {
            return <i
                className="fa fa-battery-quarter text-red mx-2 signalBatteryIcon"
                aria-hidden="true"
            />
        }
    }


    showSignalLevel = (signalStrength) => {
        if (signalStrength > 25) {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/signal4.png"
                alt="signal4"
            />;
        } else if (signalStrength >= 14 && signalStrength <= 25) {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/signal3.png"
                alt="signal3"
            />;

        } else if (signalStrength >= 8 && signalStrength <= 13) {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/signal2.png"
                alt="signal2"
            />;

        } else {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/signal1.png"
                alt="signal1"
            />;
        }
    }

    getdeviceOnline = (status) => {
        if (status === "ACTIVE") {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/online.png"
                alt="Online"
                style={{
                    borderRadius: 15,
                }}
            />;
        } else if (status === "INACTIVE") {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/redIc.png"
                alt="Offline"
                style={{
                    borderRadius: 15,
                }}
            />;
        }
        return <img
            className="statusImage d-inline-block mx-2 pl-0"
            src="../../../../assets/images/offline.png"
            alt="Offline"
            style={{
                borderRadius: 15,
            }}
        />;
    };

    render() {
        const { data, order, orderBy, filterData, selected, rowsPerPage, page } = this.state;
        let filteredData = [];
        filterData.map((n, index) => {
            const isSelected = this.isSelected(n.id);
            let batteryVoltage = n.data && n.data.vitals && n.data.vitals.batteryVoltage;
            let signalStrength = n.data && n.data.vitals && n.data.vitals.signalStrength;
            let status = n && n.status;
            let firmware = n.data && n.data.vitals && n.data.vitals.firmware;
            let time = n.data && n.data.vitals && this.formatDate(n.data.vitals.time);
            filteredData.push({
                id: index,
                nodeId: n.nodeId,
                status,
                time,
                batteryVoltage,
                signalStrength,
                firmware,
                n
            })
        })
        return (
            <div className="w-100 px-2 node-vitals" >
                <EnhancedTableToolbar openModal={() => {
                    $("#searchModalComponent").modal();
                    this.props.passDataForFilter({ filteredData, columnData });
                }} />
                <div className="flex-auto" style={{
                    background: 'white'
                }}>
                    <TableContainer className="table-responsive-material"
                        style={{
                            maxHeight: window.innerHeight - 300,
                        }}
                    >
                        <Table stickyHeader>
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                            />
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                                    let n = item.n ? item.n : item;
                                    const isSelected = this.isSelected(n.id);
                                    let batteryVoltage = n.data && n.data.vitals && n.data.vitals.batteryVoltage;
                                    let signalStrength = n.data && n.data.vitals && n.data.vitals.signalStrength;
                                    let status = n && n.status;
                                    return (
                                        <TableRow
                                            hover
                                            // onClick={event => this.handleClick(event, n.nodeId)}
                                            // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.nodeId}
                                            selected={isSelected}
                                        >
                                            {/* <TableCell padding="checkbox">
                                                <Checkbox color="primary" checked={isSelected} />
                                            </TableCell> */}
                                            <TableCell
                                                onClick={event => this.handleClick(event, n.nodeId)}
                                                onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                                                padding="none"
                                                id="deviceId"
                                            >{n.nodeId}</TableCell>
                                            <TableCell
                                                className="text-center">
                                                <Tooltip
                                                    title={`Status: ${status === "UNKNOWN" ? "NEVER ACTIVE" : status}`}
                                                    placement={'bottom-end'}
                                                >
                                                    {this.getdeviceOnline(status)}
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell
                                                className="text-center">{n.data && n.data.vitals && this.formatDate(n.data.vitals.time)}</TableCell>
                                            <TableCell
                                                className="text-center">
                                                <Tooltip
                                                    title={`Battery Level: ${batteryVoltage ? batteryVoltage : 'Not Available'}`}
                                                    placement={'bottom-end'}
                                                >
                                                    {this.showBatteryLevel(batteryVoltage)}
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell
                                                className="text-center">
                                                <Tooltip
                                                    title={`Signal Strength: ${signalStrength ? signalStrength : 'Not Available'}`}
                                                    placement={'bottom-end'}
                                                >
                                                    {this.showSignalLevel(signalStrength)}
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell className="text-center" >{n.data && n.data.vitals && n.data.vitals.firmware}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        style={{
                            width: window.innerWidth,
                        }}
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({ symbioticReducer }) => {
    return {
        deviceId: symbioticReducer.deviceId,
        nodeVitalsData: symbioticReducer.nodeVitals,
        nodeVitalsFilter: symbioticReducer.nodeVitalsFilter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNodeVitalsData: (data) => {
            dispatch({ type: "NODE_VITALS_DATA", nodeVitals: data });
        },
        updateNodeVitalsFilterData: (data) => {
            dispatch({ type: "NODE_VITALS_FILTER_DATA", nodeVitalsFilter: data });
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EnhancedTable);


// WEBPACK FOOTER //
// ./app/routes/nodeVitals/EnhancedTable.js